export default "__VITE_ASSET__Dlz_AcLh__"